/** Technologies scrolled in the marquee under the hero. Brand names, untranslated. */
export const TECH = [
  "Python",
  "Machine Learning",
  "LLMs",
  "JavaScript",
  "React",
  "TensorFlow",
  "PyTorch",
  "Node.js",
  "Swift",
  "Kotlin",
  "SQL",
  "AI Agents",
];

/** Tags shown on the AI spotlight panel. */
export const AI_TAGS = [
  "Machine Learning",
  "Deep Learning",
  "LLMs",
  "Prompt Engineering",
  "AI Agents",
];
